import {
    request,
} from '../request.js'

// 所有企业
export function reqEnterpriseList(data) {
    return request({
        url: '/web/back/sys/unit/list ',
        method: 'post',
        data
    })
}

// 删除当前企业
export function reqDelete(id) {
    return request({
        url: '/web/back/sys/unit/delete',
        method: 'delete',
        params: {
            id
        }
    })
}

// 修改
export function reqUpdate(data) {
    return request({
        url: '/web/back/sys/unit/update',
        method: 'post',
        data
    })
}

// 添加企业  
export function reqAdd(data) {
    return request({
        url: '/web/back/sys/unit/save',
        method: 'post',
        data
    })
}

// 审核和冻结
export function reqExamineUnit(data) {
	return request({
		url: "web/back/sys/unit/examineUnit",
		method: "post",
		data,
	});
}

//查看邀请码信息  
export function selectCardPage(data) {
	return request({
		url: "/web/back/sys/invivationCard/selectCardPage",
		method: "post",
		data,
	});
}
